function Footer() {
    return (
        <div>
            <footer className="bg-white">
            <p className="text-center text-blue-950 font-bold font-roboto">🪐 SpaceX - Todos os Direitos Reservados 2024&copy;</p>
            </footer>
        </div>
    );
}

export default Footer;